import React, { Component } from "react";
import { connect } from "react-redux";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "state/actions/UiActions";
import classname from "classnames";
//import Styles from "./TrocaDePlano.module.scss";


class CancelChangeOfPlan extends Component {

  constructor(props) {
    super(props);

    this.state = {
      subscriberId: this.props.subscriberId
      
    }
  }
 
  cancelChangeOfPlan=(event)=>{
    event.preventDefault();
   
    let token = this.props.token.Authorization;
    ExecuteRequest(
      GlamboxEndpoints.Subscriber.cancelChangeOfPlan,
      {
        subscriberId: this.state.subscriberId,
      },
      "PUT",
      {
        Authorization: token
      },
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          this.props.successAlert("Agendamento Cancelado");
          this.props.callback('cancelled');
          this.props.onCloseModal();
        } else {
          this.props.errorAlert(
            (result && result.message)
              ? result.message
              : "Erro"
          );
        }
      }
    );
   
  }
  showValidationMessage() {
    const validationMessage = this.state.validationMessage;
    return (<h3>{validationMessage}</h3>);
  }

  render() {
    return (
      <div className={"text-center"}>
        <h3>Tem certeza de que deseja cancelar a troca de plano?</h3>       
        <button className={"btn btn-light-lime"} onClick={this.props.onCloseModal}>Voltar</button>
        &nbsp;
        <button className={"btn btn-light-pink"} onClick={this.cancelChangeOfPlan}>Sim</button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {    
    token: state.token.data    
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    }
    , errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    }
  }
}

CancelChangeOfPlan = connect(mapStateToProps, mapDispatchToProps)(CancelChangeOfPlan);

export { CancelChangeOfPlan };